import TrackElements from '@capsule/track-elements'

/**
 * PushDiaporama
 * A class to manage the behavior and tracking of the Push Diaporama component.
 * @module PushDiaporama
 */
export default class PushDiaporama {
	// The container element for the Push Diaporama
	container: HTMLElement | null

	// The button element inside the Push Diaporama container
	button: HTMLElement | null | undefined

	// Instance of TrackElements to handle tracking events
	trackElements: TrackElements | null

	/**
	 * Constructor
	 * Initializes the container and button elements.
	 */
	constructor() {
		this.container = document.querySelector('.pushDiaporama')
		this.button = this.container?.querySelector('.pushDiaporama-button a')
		this.trackElements = null
	}

	/**
	 * Initializes the Push Diaporama tracking.
	 * Sets up tracking for the container display and button click events.
	 */
	init() {
		if (!this.button || !this.container) return

		this.trackElements = new TrackElements([
			{
				// Track when the container is displayed
				element: this.container,
				display: {
					event: 'button_display',
					button_name: 'cta-push-diaporama'
				}
			},
			{
				// Track when the button is clicked
				element: this.button,
				click: {
					event: 'button_click',
					button_name: 'cta-push-diaporama'
				}
			}
		])
		this.trackElements.init()
	}
}
